/*
 * @Description: 表单设计
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { tools } from '@/utils/tools.js';
import { reactive, toRefs } from 'vue';
import i18n from '@/locales/index';
import { confine, fieldType, defaultValOrgIds } from '@/utils/const';
import { setService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useSettingStore, useUserStore, useGrayscaleStore } from '@/store';
import useFields from '@/hooks/fields';
const { fieldIconMapping } = useFields();
// import useUpdateFields from '@/hooks/update-fields';
// const { setCondition } = useUpdateFields();
import _ from 'lodash';
export default function useObjectForm() {
  const settingStore = useSettingStore();
  const userStore = useUserStore();
  const { grayList } = useGrayscaleStore();
  const data = reactive({
    inputList: [0, 1, 7, 11, 13, 16, 23, 26], //请输入的字段
    onlineFeilds: [18, 26, 27], //需要整行显示的字段类型
    selectFieldTypes: [2, 3, 4, 5, 10], //选项类型的
    relationFieldTypes: [12, 25], //查找关联
    noFeildExt: [0, 1, 11, 26], //没有fieldExt的字段类型
    noJsonFeildExt: [8, 9, 12, 13, 22, 24, 25, 27], //不需要json的字段类型
    advancedFieldList: [11, 12, 13, 18, 21, 24, 25, 26, 27], //高级字段类型
    settingFieldList: [], //字段清单
    basisList: [], //普通字段
    advancedList: [], //高级字段
    componentList: [], //组件
    collapseList: [], //字段合集
    entitySettingFieldExt: null, //字段设置信息
    enableList: [], //所有启用的字段
    getCheckComputerFieldObj: {}, //所有计算字段的信息及异常信息
    fieldForm: null, //字段信息
    getDefaultRule: false,
    countFieldTypes: [0, 1, 7, 16, 23], //参与计算字段默认值类型（单行，多行，数字，金额，百分比）
    ruleFieldList: []
  });

  // 自动生成字段key,随机数只含字母和数字
  const createFieldKey = (value) => {
    const tool = tools.randomString();
    const objTxt = {
      0: 'input',
      1: 'textarea',
      2: 'radio',
      3: 'checkbox',
      4: 'select_single',
      5: 'select_multiple',
      6: 'people',
      7: 'number',
      8: 'date',
      9: 'date_range',
      10: 'cascade',
      11: 'hyperlink',
      12: 'association',
      13: 'code',
      16: 'amount',
      18: 'attachment',
      21: 'quote',
      22: 'depart',
      23: 'percentage',
      24: 'calculation',
      25: 'association',
      26: 'editor',
      27: 'sub_form',
      31: 'query_record',
      30: 'association_record'
    };
    return `${objTxt[value] || ''}_${tool}`;
  };
  // 处理返回的默认值
  const getFieldDefaultValue = (i, j) => {
    if (j.fieldType === 3 || j.fieldType === 5) {
      i.defaultValue = i?.defaultValue ? i?.defaultValue?.split(',') : [];
    } else if (j.fieldType === 6) {
      //人员  新增需求 本次是单选 上一次是多选(大于2) 时  清空数据
      // if (i?.fieldExt && i?.fieldExt?.single == 1 && i.defaultValue?.userIds?.length > 1) {
      //   i.fv = '';
      //   i.defaultValue = { departList: [], userList: [] };
      // } else {
      i.fv = i.defaultValue ? i.defaultValue?.userIds?.map((v) => v?.name) : '';
      i.defaultValue =
        i.defaultValue && i.defaultValue?.userIds
          ? {
              departList: [],
              userList: i.defaultValue?.userIds?.map((u) => {
                return {
                  userName: u.name,
                  id: u.id,
                  avatarOrigin: u.avatar
                };
              })
            }
          : '';
      // }
    } else if (j.fieldType === 7) {
      i.defaultValue = i.defaultValue ? Number(i.defaultValue) : '';
    } else if (j.fieldType === 9) {
      //日期
      const hasRangeValue = tools.isJSON(i?.defaultValue) && JSON.parse(i?.defaultValue)?.beginDate && JSON.parse(i?.defaultValue)?.endDate;
      if (hasRangeValue) {
        i.defaultValue = Object.values(JSON.parse(i?.defaultValue));
      } else {
        i.defaultValue = '';
      }
    } else if (j.fieldType === 10) {
      //级联选择
      i.defaultValue = i.defaultValue ? i.defaultValue?.split('/') : '';
    } else if (j.fieldType === 16) {
      //金额
      i.defaultValue = !isNaN(parseFloat(i.defaultValue)) ? tools.getPrice(i.defaultValue) : '';
    } else if (j.fieldType === 18) {
      //附件
      i.defaultValue = i.defaultValue ? JSON.parse(i.defaultValue) : '';
    } else if (j.fieldType === 23) {
      //百分比
      i.defaultValue = !isNaN(parseFloat(i.defaultValue)) ? tools.getPercentage(i.defaultValue) : '';
    } else if (j.fieldType === 22) {
      //部门  新增需求 本次是单选 上一次是多选(大于2) 时  清空数据
      // if (i?.fieldExt == 1 && i.defaultValue?.departIds?.length > 1) {
      //   i.fv = '';
      //   i.defaultValue = { departList: [], userList: [] };
      // } else {
      i.fv = i.defaultValue ? i.defaultValue?.departIds?.map((v) => v?.name) : '';
      i.defaultValue =
        i.defaultValue && i.defaultValue?.departIds
          ? {
              departList: i.defaultValue?.departIds?.map((u) => {
                return {
                  departmentName: u.name,
                  id: u.id
                };
              }),
              userList: []
            }
          : '';
      // }
    }
  };
  // 过滤掉禁用且数据库里没有的选项默认值(2,3,4,5 )
  const fitterDefaultValue = (inputList, fieldExt) => {
    const filteredInputList = inputList?.filter((item) => {
      const foundItem = fieldExt?.find((field) => field.value === item && field.isEnabled);
      return !!foundItem; // 如果找到且启用，则保留该项
    });
    return filteredInputList;
  };
  // 过滤掉禁用且数据库里没有的选项默认值(10)
  const filterSelectDefaultValue = (inputList, fieldExt) => {
    const findValue = (list, value, level = 0) => {
      if (!list || level >= inputList.length) return false;

      for (const item of list) {
        if (item.value === value && item.isEnabled) {
          // 如果当前层级匹配，且是最后一层，则返回true
          if (level === inputList.length - 1) return true;
          // 否则继续在子节点中查找
          if (item.children && findValue(item.children, inputList[level + 1], level + 1)) {
            return true;
          }
        }
      }
      return false;
    };

    return findValue(fieldExt, inputList[0]);
  };
  // 获取默认值规则的灰度
  const getGrayscale = () => {
    return defaultValOrgIds.includes(userStore.userInfo?.orgId);
  };

  const checkFieldValue = (fieldValue) => {
    return fieldValue === null || fieldValue === undefined || fieldValue === '' || (typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0 && !Array.isArray(fieldValue)) || (Array.isArray(fieldValue) && fieldValue.length === 0);
  };
  // 处理子表单默认值
  const defaultValFormatSubForm = (obj) => {
    if (!obj) return;
    return Object.values(obj).map((group) => {
      return group.reduce((acc, item) => {
        acc[item.fieldKey] = checkFieldValue(item.defaultValue) ? '' : item.defaultValue;
        return acc;
      }, {});
    });
  };

  //处理上传的默认值
  const uploadDefaultVal = (i) => {
    if (i.fieldType === 3 || i.fieldType === 5) {
      i.defaultValue = i?.defaultValue && i?.defaultValue?.length > 0 ? i.defaultValue?.filter((item) => item).join(',') : i.defaultValue ?? '';
    } else if (i.fieldType === 9) {
      const v = { beginDate: i.defaultValue?.[0], endDate: i.defaultValue?.[1] };
      i.defaultValue = v ? JSON.stringify(v) : '';
    } else if (i.fieldType === 10) {
      i.defaultValue = i?.defaultValue && Array.isArray(i.defaultValue) ? i.defaultValue?.join('/') : '';
      // if (i?.defaultValue && i?.defaultValue?.length > 0 && i?.fieldExt?.length > 0) {
      //   if (filterSelectDefaultValue(i.defaultValue, i.fieldExt)) {
      //     i.defaultValue = i.defaultValue?.join('/');
      //   } else {
      //     i.defaultValue = '';
      //   }
      // } else {
      //   i.defaultValue = '';
      // }
    } else if (i.fieldType == 18) {
      //附件
      i.defaultValue = i.defaultValue ? JSON.stringify(i.defaultValue) : null;
    } else if (i.fieldType == 6) {
      //人员
      const userArray = i.defaultValue?.userList?.map((useritem) => {
        return useritem?.id;
      });
      i.defaultValue = i.defaultValue ? JSON.stringify({ userIds: userArray?.length ? userArray : [], departIds: [] }) : '';
    } else if (i.fieldType == 22) {
      //部门
      const departArray = i.defaultValue?.departList?.map((departitem) => {
        return departitem?.id;
      });
      i.defaultValue = i.defaultValue ? JSON.stringify({ userIds: [], departIds: departArray?.length ? departArray : [] }) : '';
    } else if (i.fieldType === 7) {
      //数字
      i.defaultValue = !isNaN(parseFloat(i.defaultValue)) ? i.defaultValue : '';
    } else if (i.fieldType === 16) {
      //金额
      i.defaultValue = !isNaN(parseFloat(i.defaultValue)) ? tools.setPrice(i.defaultValue) : '';
    } else if (i.fieldType === 23) {
      //百分比
      i.defaultValue = !isNaN(parseFloat(i.defaultValue)) ? tools.setPercentage(i.defaultValue) : '';
    }
  };
  //重置按钮的id
  const resetIds = (modules) => {
    return modules?.map((item) => {
      if (item?.type == 40) {
        //按钮
        if (!item?.layoutId || !item?.parentId) {
          item.id = null;
          return item;
        }
      }
      return item;
    });
  };
  //处理上传的参数
  const getFormatModules = (i) => {
    if (i?.isExistDefValue == 1) uploadDefaultVal(i); //处理自定义默认值

    const typeMap = {
      27: '35',
      30: '30',
      31: '31'
    };
    const isTableType = typeMap[i.fieldType] ?? typeMap[i?.type] ?? '20';

    return {
      id: i?.modulesId || '', //编辑
      parentId: i?.parentId || '', //编辑
      label: i.label,
      tableOperation: i.type == 30 && i?.tableOperation?.batchTableAdd ? i?.tableOperation : null,
      tableOperationConditions: i.type == 30 && i?.tableOperation?.batchTableAdd ? i.tableOperationConditions : null, //查找关联批量 数据范围条件
      value: getRecordType(i?.type) ? i?.value : i.fieldKey, //如果是表格的话就看下有没有value，编辑时后端会返回标识用来同步布局,
      type: isTableType,
      businessData: String(i?.businessData) || null,
      attributeRead: i?.attributeRead,
      attributeHide: i?.attributeHide,
      associateKey: i?.associateKey || null, //子表单关联主键
      toast: i?.toast || null,
      memo: i?.memo || null,
      displayOneLine: i.displayOneLine,
      isExistDefValue: ![3, 4].includes(i.isExistDefValue) ? i.isExistDefValue : null,
      defaultValue: ![3, 4].includes(i.isExistDefValue) ? (i?.isExistDefValue == 1 ? i.defaultValue : null) : null,
      placeholder: i?.placeholder || null,
      isRequired: i?.isRequired ? 1 : 0,
      permission:
        i.fieldType === 27
          ? JSON.stringify({
              canEdit: i?.permission,
              detail: {
                edit: i?.permissionDetail?.indexOf('edit') > -1 ? 1 : 0,
                remove: i?.permissionDetail?.indexOf('remove') > -1 ? 1 : 0,
                add: i?.permissionDetail?.indexOf('add') > -1 ? 1 : 0,
                insert: i?.permissionDetail?.indexOf('insert') > -1 ? 1 : 0
              }
            })
          : null,
      modules:
        i.fieldType === 27
          ? i.modules?.map((im) => {
              return { ...getFormatModules(im) };
            })
          : getRecordType(i?.type)
          ? resetIds(i.modules)
          : null,
      dataRangeConditions: i?.type == 31 ? i?.dataRangeConditions || null : null, //查询记录
      dataRange: i?.type == 31 ? i?.dataRange || null : null
    };
  };
  // 是否可编辑

  const setIsEnabled = (ele, entity) => {
    if (ele?.systemFieldtype == 0 || (entity == 1 && ele?.fieldKey == 'cluePoolId' && ele?.systemFieldtype == 1) || (entity == 16 && (ele?.fieldKey == 'businessId' || ele?.fieldKey == 'entityType') && ele?.systemFieldtype == 1) || ele?.mainField || ele?.fieldKey === 'chargePerson') {
      return true;
    } else {
      return false;
    }
  };
  //处理返回的字段信息
  const updateSettings = (params) => {
    params?.feildsResult?.forEach((i) => {
      i.label = i.fieldName;
      i.systemFieldtype = i.type; //字段类型
      i.settingId = i.id; //字段id
      // i.fieldExt = i?.fieldExt && tools.isJSON(i?.fieldExt) && i.fieldType != 24 ? JSON.parse(i.fieldExt) : i?.fieldExt || null;
      i.placeholder = i?.placeholder ? i?.placeholder : data.inputList.includes(i.fieldType) ? i18n.global.t('请输入') + i.fieldName : i18n.global.t('请选择') + i.fieldName;

      i.isExistDefValue = 0; //0-不展示默认值 1-展示统一默认值
      i.defaultValue = null; //默认值

      i.memo = ''; //附加说明

      i.displayOneLine = data.onlineFeilds.includes(i.fieldType) ? 1 : 0; //是否整行展示

      i.toast = ''; //提示
      i.businessData = '1'; //编辑页--代表是否可编辑 0-不可编辑 1-可修改 2-满足条件编辑
      i.isModify = false; //代表内容是否被修改过，初始值为false
      if (!setIsEnabled(i, params.entity)) {
        if (params?.getIds?.length > 0 && params?.getIds.indexOf(i.id) != -1) {
          i.isEnabled = true;
        } else {
          i.isEnabled = false;
        }
      }
      if (i.value == 21) {
        //引用字段
        i.businessData = '0'; //不可修改
      }

      if (i.fieldType === 24) {
        //计算字段
        i.businessData = '0'; //不可修改
      }
      if (i.fieldType === 27) {
        //子表单
        // const business = i.business && tools.isJSON(i?.business) ? JSON.parse(i?.business) : {};
        // i.businessData = business?.businessData || null; //子表单对象id
        // i.associateKey = business?.associateKey || null; //子表单关联主键
        i.permission = 1;
        i.modules = [];
        i.permissionDetail = ['edit', 'remove', 'add', 'insert'];
        i.children?.forEach((sub) => {
          sub.isModify = false; //代表内容是否被修改过，初始值为false
          sub.label = sub.fieldName;
          sub.systemFieldtype = sub.type; //字段类型
          sub.settingId = sub.id; //字段id

          sub.isExistDefValue = 0; //0-不展示默认值 1-展示统一默认值
          sub.defaultValue = null; //默认值

          sub.memo = ''; //附加说明

          sub.displayOneLine = data.onlineFeilds.includes(sub.fieldType) ? 1 : 0; //是否整行展示

          sub.toast = ''; //提示
          sub.businessData = '1'; //编辑页--代表是否可编辑 0-不可编辑 1-可修改 2-满足条件编辑

          // sub.fieldExt = sub?.fieldExt && tools.isJSON(sub?.fieldExt) && sub.fieldType != 24 ? JSON.parse(sub.fieldExt) : sub?.fieldExt || null;
          sub.placeholder = sub?.placeholder ? sub?.placeholder : data.inputList.includes(sub.fieldType) ? i18n.global.t('请输入') + sub.fieldName : i18n.global.t('请选择') + sub.fieldName;
          // if (sub.type != 0) {
          //   if (params?.getIds?.length > 0 && params?.getIds.indexOf(sub.id) != -1) {
          //     sub.isEnabled = true;
          //   } else {
          //     sub.isEnabled = false;
          //   }
          // }

          if (data.selectFieldTypes.includes(sub.fieldType)) {
            //选项类型的
            sub.checkedValue = 0;
            if (sub.globalFieldId) {
              //全局字段给个标识
              sub.checkedValue = 1;
            }
          }
        });
      }
      if (data.selectFieldTypes.includes(i.fieldType)) {
        //选项类型的
        i.checkedValue = 0;
        if (i.globalFieldId) {
          //全局字段给个标识
          i.checkedValue = 1;
        }
      }
    });
    return params.feildsResult;
  };
  // 调用详情时把表单设计中不存在或者禁用的字段过滤掉
  const filterModules = (resultModules, settings) => {
    resultModules?.forEach((item) => {
      item?.modules?.forEach((i, index) => {
        if (i.type == 20 || i.type == 35) {
          const getSettings = settings.filter((j) => j.fieldKey == i.value && j.isEnabled);
          if (getSettings?.length == 0) {
            item.modules.splice(index, 1);
          }
          if (getSettings && getSettings?.length > 0 && i.type == 35) {
            //子表单
            i?.modules?.forEach((ele, subIndex) => {
              if (ele.type == 20) {
                if (getSettings?.settings?.filter((k) => k.fieldKey == ele.value && k.isEnabled).length == 0) {
                  i.modules.splice(subIndex, 1);
                }
              }
            });
          }
        }
      });
    });
    return resultModules;
  };
  //保存时把不存在的字段过滤掉
  const filterIsEnabledModules = (resultModules) => {
    resultModules?.forEach((item) => {
      item?.modules?.forEach((i, index) => {
        if (getRecordType(i?.type)) {
          //查找,关联记录直接跳过
          return;
        }
        if (i.fieldType == 27) {
          //子表单
          i?.modules?.forEach((ele, subIndex) => {
            if (!ele?.settingId) {
              //字段不存在
              i.modules.splice(subIndex, 1);
            }
          });
        }
        if (!i?.settingId) {
          //字段不存在
          item.modules.splice(index, 1);
        }
      });
    });
    return resultModules;
  };
  // 把子表处理成级联
  const changeIdToKey = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map((item) => changeIdToKey(item));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {};
      for (const key in obj) {
        if (key === 'id') {
          newObj['key'] = obj[key];
          newObj['id'] = obj[key];
        } else if (key === 'children') {
          newObj['children'] = changeIdToKey(obj[key]);
        } else {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    }
    return obj;
  };
  //获取字段清单
  const getTable = async (params) => {
    let subFormNum = 0; //子表单数量
    try {
      const json = await setService.sysEntitySetting(params);
      if (!json.error) {
        const settingList = json?.result;
        // 业务规则用
        data.ruleFieldList = json?.result;
        settingList?.map((item) => {
          item.oldSonFieldName = item?.fieldName || fieldType?.find((el) => el.value == item.fieldType)?.label;
          if (item.fieldType === 27) {
            item.fieldExt = item?.settings?.[0]?.entityId || '';
            item?.settings?.map((sonItem) => {
              sonItem.oldSonFieldName = `${item.oldSonFieldName}.${sonItem?.fieldName || fieldType?.find((el) => el.value == sonItem.fieldType)?.label}`; //把名称拼接起来
            });

            item.children = item?.settings || [];

            subFormNum = subFormNum + 1;
          }
        });
        settingStore.updateSubNum(subFormNum); //存储子表单数据
        data.settingFieldList = changeIdToKey(settingList);
      } else {
        Message.error(json.error?.msg || i18n.global.t('操作失败'));
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 左侧字段信息
  const getFieldTypeList = () => {
    data.basisList = [];
    data.advancedList = [];
    data.componentList = [];
    data.collapseList = [];
    fieldType.forEach((cur) => {
      cur.modulesId = ''; //布局模块id
      cur.parentId = ''; //布局id
      (cur.settingId = ''), //字段id
        (cur.type = 2); //自定义字段
      cur.systemFieldtype = 2; //自定义字段
      cur.fieldType = cur.value;
      cur.fieldExt = null;
      cur.isExistDefValue = 0; //0-不展示默认值 1-展示统一默认值
      cur.defaultValue = null; //默认值
      //cur.display = 1; //0-默认不可见，1-默认可见 2-满足条件可见
      //cur.displayConditions = null; //满足条件可见条件
      cur.memo = ''; //附加说明
      cur.placeholder = data.inputList.includes(cur.value) ? i18n.global.t('请输入') + cur.label : i18n.global.t('请选择') + cur.label;
      cur.displayOneLine = data.onlineFeilds.includes(cur.value) ? 1 : 0; //是否整行展示
      cur.isRequired = false; //0-非必填 1-必填 2-满足条件必填
      cur.isEnabled = false; //字段状态--默认是禁用
      cur.toast = ''; //提示
      cur.businessData = '1'; //编辑页--代表是否可编辑 0-不可编辑 1-可修改 2-满足条件编辑
      cur.attributeRead = []; // 只读  1 新建页 2编辑页 3详情页 4 列表页
      cur.attributeHide = []; // 隐藏  1 新建页 2编辑页 3详情页
      cur.permission = null;
      cur.layoutFieldType = '20'; //布局字段类型 20.普通字段 30.关联记录 31.查询记录
      cur.fieldKey = '';
      if (data.selectFieldTypes.includes(cur.value)) {
        //选项类型的
        cur.checkedValue = 0; //默认是自定义选项
        cur.globalFieldId = null; //全局字段id为空
      }
      if (cur.value == 6) {
        //人员
        cur.fieldExt = {
          single: 1
        };
      }
      if (cur.value == 7) {
        //数字
        cur.fieldExt = {
          numberFormat: '0', //默认是整数
          numberUnit: null, //单位是空
          isPermillage: false, //显示千分符
          isZero: false //末尾省略0
        };
      }
      if (cur.value == 8) {
        //日期
        cur.fieldExt = 'YYYY/MM/DD';
      }
      if (cur.value == 9) {
        //日期范围
        cur.fieldExt = '0';
      }
      if (cur.value == 13) {
        //编码
        cur.fieldExt = '1';
        cur.encodings = [
          {
            type: 1,
            prefix: '',
            suffix: '',
            digit: 6
          }
        ];
      }
      if (cur.value == 16) {
        //金额
        cur.fieldExt = {
          numberFormat: '0', //默认是整数
          isPermillage: true, //显示千分符
          isZero: false //末尾省略0
        };
      }
      if (cur.value == 18) {
        //附件
        cur.fieldExt = {
          limit: '10',
          accept: ['0'],
          fileType: '1',
          uploadType: '',
          watermarkType: '1',
          watermarkValue: ['1', '2', '3']
        };
      }
      if (cur.value == 21) {
        //引用字段
        cur.isRequired = false;
        cur.fieldExt = {
          findAssociateField: '',
          referenceField: ''
        };
        cur.businessData = '0'; //不可修改
      }
      if (cur.value == 22) {
        //部门
        cur.fieldExt = '1';
      }
      if (cur.value == 23) {
        //百分比
        cur.fieldExt = {
          numberFormat: '0', //默认是整数
          isPermillage: false, //显示千分符
          isZero: false //末尾省略0
        };
      }
      if (cur.value == 24) {
        //计算字段
        cur.businessData = '0'; //不可修改
      }

      if (cur.value == 27) {
        cur.permission = 1;
        cur.modules = [];
        cur.permissionDetail = ['edit', 'remove', 'add', 'insert'];
      }
      if (data.advancedFieldList.includes(cur.value)) {
        data.advancedList.push(cur);
      } else {
        data.basisList.push(cur);
      }
    });
    const tableModules = [
      {
        label: i18n.global.t('关联记录'),
        icon: '',
        display: 1,
        type: '30',
        layoutFieldType: '30',
        isRequired: false,
        associateKey: '',
        businessData: '',
        modules: []
      },
      {
        label: i18n.global.t('查询记录'),
        icon: '',
        display: 1,
        type: '31',
        layoutFieldType: '31',
        isRequired: false,
        associateKey: '',
        businessData: '',
        modules: [],
        dataRange: 1,
        dataRangeConditions: null
      }
    ];
    data.componentList.push(...tableModules);
    if (grayList?.['Layout:childForm'] === false) {
      //子表单灰度外
      data.advancedList = data.advancedList.filter((item) => item.value != 27);
    }
    data.collapseList = [data.basisList, data.advancedList, data.componentList];
  };
  // 处理返回的布局数据
  const updateModules = (resultModules, settings) => {
    resultModules?.forEach((item) => {
      item.modulesId = item?.id || ''; //用一个新字段代表modules这条数据的id
      item.parentId = item?.parentId || '';
      item.modules?.forEach((i) => {
        i.modulesId = i?.id || '';
        i.parentId = i?.parentId || '';
        if (i.type == 20) {
          settings.forEach((j) => {
            if (j.fieldKey == i.value) {
              i.label = j.fieldName;
              i.fieldName = j.fieldName;
              // i.fieldExt = j?.fieldExt && tools.isJSON(j?.fieldExt) && j.fieldType != 24 ? JSON.parse(j.fieldExt) : j?.fieldExt || null;
              i.fieldKey = j.fieldKey;
              i.fieldType = j.fieldType;
              i.systemFieldtype = j.type; //字段类型
              i.isRequired = j.isRequired; //0-非必填 1-必填 2-满足条件必填
              i.isEnabled = j.isEnabled; //字段状态
              i.businessData = i?.businessData || '1'; //编辑也是否可修改
              i.attributeRead = j?.attributeRead || [];
              i.attributeHide = j?.attributeHide || [];
              i.settingId = j.id; //字段id
              i.mainField = j.mainField; //主字段
              // i.canDisabled = j.canDisabled;
              i.isModify = false;
              i.complete = j.complete; //是否是异常字段标识
              //   if (j.fieldType === 12 || j.fieldType === 25) {
              //     //查找关联
              //     // i.dataRange = j.dataRange ?? 1;
              //     // i.dataRangeConditions = j.dataRangeConditions;
              //     // i.condition = null;
              //     // i.selectFields = j.selectFields;
              //     // i.popFields = j.popFields;
              //   }
              getFieldDefaultValue(i, j);
              if (data.selectFieldTypes.includes(j.fieldType)) {
                //选项类型的
                i.checkedValue = 0;
                if (j.globalFieldId) {
                  //全局字段给个标识
                  i.checkedValue = 1;
                  i.globalFieldId = j.globalFieldId;
                }
              }

              // i.placeholder = i?.placeholder ? i?.placeholder : data.inputList.includes(j.fieldType) ? i18n.global.t('请输入') + j.fieldName : i18n.global.t('请选择') + j.fieldName;
              i.placeholder = i?.placeholder ? i?.placeholder : '';
            }
          });
        }
        if (i.type == 35) {
          //子表单
          const _subFormField = settings?.find((lel) => lel.fieldKey == i.value);
          if (_subFormField) {
            const _permission = i?.permission && tools.isJSON(i?.permission) ? JSON.parse(i?.permission) : {};
            // const business = _subFormField.business && tools.isJSON(_subFormField?.business) ? JSON.parse(_subFormField?.business) : {};
            i.permission = _permission?.canEdit;
            const _permissionDetail = [];
            if (_permission?.detail != null) {
              Object.keys(_permission?.detail).map((pd) => {
                if (_permission?.detail?.[pd]) {
                  _permissionDetail.push(pd);
                }
              });
            }

            i.label = _subFormField?.fieldName;
            i.fieldType = _subFormField?.fieldType;
            i.fieldKey = _subFormField.fieldKey;
            // i.fieldExt = _subFormField?.fieldExt || null;
            i['permissionDetail'] = _permissionDetail;
            i.settingId = _subFormField.id; //字段id
            i.systemFieldtype = _subFormField.type; //字段类型
            i.isRequired = _subFormField.isRequired; //0-非必填 1-必填 2-满足条件必填
            i.isEnabled = _subFormField.isEnabled; //字段状态
            i.attributeRead = _subFormField.attributeRead || []; //字段状态
            i.attributeHide = _subFormField.attributeHide || []; //字段状态
            // i.businessData = i?.businessData || null; //子表单对象id
            // i.associateKey = i?.associateKey || null; //子表单关联主键
            i.isModify = false; //代表内容是否被修改过，初始值为false
            i.fieldExt = _subFormField?.children?.[0]?.entityId || '';
            i.complete = _subFormField.complete; //是否是异常字段标识
            const _modules = [];
            i?.modules?.map((im) => {
              const imFind = _subFormField?.children?.find((sf) => sf.fieldKey == im.value);

              if (imFind) {
                // (im.fieldExt = imFind?.fieldExt && tools.isJSON(imFind?.fieldExt) ? JSON.parse(imFind.fieldExt) : imFind?.fieldExt || null),
                getFieldDefaultValue(im, imFind);
                if (imFind.fieldType === 12 || imFind.fieldType === 25) {
                  //查找关联
                  // im.dataRange = imFind.dataRange ?? 1;
                  // im.dataRangeConditions = imFind.dataRangeConditions;
                  // im.condition = null;
                  // im.selectFields = imFind.selectFields;
                  // im.popFields = imFind.popFields;
                }
                if (data.selectFieldTypes.includes(imFind.fieldType)) {
                  //选项类型的
                  im.checkedValue = 0;
                  if (imFind.globalFieldId) {
                    //全局字段给个标识
                    im.checkedValue = 1;
                    im.globalFieldId = imFind.globalFieldId;
                  }
                }
                _modules.push({
                  ...im,
                  ...{
                    modulesId: im?.id || '',
                    parentId: im?.parentId || '',
                    label: imFind?.fieldName,
                    fieldKey: imFind?.fieldKey,
                    fieldType: imFind?.fieldType,
                    systemFieldtype: imFind.type, //字段类型
                    isRequired: imFind.isRequired, //0-非必填 1-必填 2-满足条件必填
                    isEnabled: imFind.isEnabled, //字段状态
                    businessData: imFind?.businessData || '1', //编辑也是否可修改
                    attributeRead: imFind?.attributeRead || [],
                    attributeHide: imFind?.attributeHide || [],
                    settingId: imFind.id, //字段id、
                    isModify: false, //代表内容是否被修改过，初始值为false
                    entityId: imFind.entityId, //子表的entityId
                    placeholder: im?.placeholder ? im?.placeholder : '',
                    complete: imFind.complete //是否是异常字段标识
                    // placeholder: imFind?.placeholder ? imFind?.placeholder : data.inputList.includes(imFind.fieldType) ? i18n.global.t('请输入') + imFind.fieldName : i18n.global.t('请选择') + imFind.fieldName
                  }
                });
              }
            });
            i.modules = _modules;
          }
        }
        if (getRecordType(i?.type)) {
          //关联记录、查询记录
          i.fieldKey = i.id;
        }
      });
    });
    return resultModules;
  };
  // 校验子表单的子字段数量（子表里至少有一个自定义字段）
  const checkSubFormNums = (groupList) => {
    return groupList.some((list) => {
      return list.modules.some((sub) => {
        return sub.fieldType === 27 && (!sub.modules || sub.modules.length === 0);
      });
    });
  };
  // 获取字段fieldExt信息
  const getEntityFieldExt = async (params, setStore = true) => {
    const getParams = {
      settingId: params.settingId,
      apiIndex: Math.random(),
      isDefault: !getGrayscale() ? true : false //是否查询默认值
    };

    settingStore.clearFieldExt(); //清除存储数据

    data.entitySettingFieldExt = null;
    try {
      const json = await setService.sysEntityfieldExt(getParams);
      if (!json.error) {
        json.result.fieldExt = json.result?.fieldExt && tools.isJSON(json.result?.fieldExt) && params.fieldType != 24 ? JSON.parse(json.result.fieldExt) : json.result?.fieldExt || null;
        data.entitySettingFieldExt = json.result;
        if (setStore) {
          settingStore.setFieldExt(data.entitySettingFieldExt); //存储数据
        }
      }
    } catch (e) {
      data.entitySettingFieldExt = null;
      console.log(e);
    }
  };
  // 获取所有字段 不包含fieldExt信息
  const getAllFields = async (params) => {
    data.enableList = [];
    if (params) {
      try {
        const json = await setService.sysEntitySetting(params);
        //已启用的字段
        data.enableList = json?.result || [];

        return data;
      } catch (e) {
        data.enableList = [];
        return data;
      }
    } else {
      data.enableList = [];
      return data;
    }
  };

  // 计算字段是否异常(init:true 初始化，false：更新) item, fieldObj
  const computerFieldCheck = async (getParams, fieldObj) => {
    // const params = { settingId: getParams.settingId, apiIndex: Math.random() };

    try {
      const json = await setService.computerFieldCheck(getParams);
      if (!json.error) {
        fieldObj[getParams.settingId] = json?.result;
      } else {
        Message.error(json.error?.msg || i18n.global.t('操作失败'));
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 布局里计算字段获取是否异常信息（初始化）
  const checkComputerField = async (modules) => {
    const setFieldAllPromises = [];
    const setCheckComputerFieldObj = {};
    modules?.forEach((item) => {
      item?.modules?.forEach((i) => {
        if (i.fieldType == 24) {
          setFieldAllPromises.push(computerFieldCheck({ settingId: i.settingId, apiIndex: Math.random() }, setCheckComputerFieldObj));
        }
      });
    });
    await Promise.all(setFieldAllPromises);
    data.getCheckComputerFieldObj = setCheckComputerFieldObj;
    console.log('data.getCheckComputerFieldObj------', data.getCheckComputerFieldObj);
  };
  // 更新布局里计算字段获取是否异常信息 type:1 新增计算字段，2：编辑计算字段
  const updateComputerCheckError = async (getParams) => {
    // const setFieldAllPromises = [];
    const params = { settingId: getParams.settingId, apiIndex: Math.random() };

    if (getParams?.tempSettingIds) {
      params.tempSettingIds = getParams?.tempSettingIds || '';
    }
    if (getParams?.tempDisableSettingIds) {
      params.tempDisableSettingIds = getParams?.tempDisableSettingIds || '';
    }

    await computerFieldCheck(params, data.getCheckComputerFieldObj);
    // await Promise.all(setFieldAllPromises);
    // console.log('data.getCheckComputerFieldObj--------', data.getCheckComputerFieldObj);
  };
  // 更新计算字段异常结果 true、false
  const updateCheckResult = () => {
    for (const key in data.getCheckComputerFieldObj) {
      const field = data.getCheckComputerFieldObj?.[key];
      if (field) {
        const resultSettings = field?.resultSetting || [];
        if (resultSettings?.length === 0) {
          field['checkResult'] = true;
          continue; // 继续下一个字段的检查
        }
        // 假定检查结果为true
        field['checkResult'] = true;
        // 检查是否存在任何异常配置
        for (const setting of resultSettings) {
          if (setting.disableFieldSettingId && setting.disableFieldSettingId?.length > 0) {
            field['checkResult'] = false;
            break;
          }
        }
      }
    }
  };
  // 编辑计算字段之后，更新异常
  const updateCheckResultError = (params) => {
    data.getCheckComputerFieldObj[params.settingId].checkResult = true;
  };
  //启用禁用字段更改计算字段的异常信息 isEnabled(false:禁用，删除，true：启用)
  const updateSettingIds = (settings, paramIds, setKey, setKey2) => {
    settings.forEach((setting) => {
      const idsToRemove = setting[setKey]?.filter((id) => paramIds.has(id)) || [];
      // console.log('idsToRemove-------', idsToRemove);
      if (idsToRemove.length > 0) {
        // 将id从setKey对应的数组中移除，并添加到setKey2对应的数组中
        idsToRemove.forEach((id) => {
          if (!setting[setKey2]) setting[setKey2] = [];
          setting[setKey2].push(id);
          const index = setting[setKey].indexOf(id);
          if (index !== -1) {
            setting[setKey].splice(index, 1);
          }
        });
      }
    });
  };
  //启用禁用字段更改计算字段的异常信息 isEnabled(false:禁用，删除，true：启用) getModules：布局信息，params：禁用或者启用的字段合集 tempSettingIds：启用或者禁用字段ids
  const updateCheckComputerField = async (getModules, params, isEnabled, getTempSettingIds) => {
    const paramIds = new Set(Array.isArray(params) ? params.map((param) => param?.settingId) : [params?.settingId]);
    const setKey = isEnabled ? 'disableFieldSettingId' : 'enableFieldSettingId';
    const setKey2 = isEnabled ? 'enableFieldSettingId' : 'disableFieldSettingId';
    const setFieldAllPromises = [];
    // console.log('updateCheckComputerField-------', getModules, paramIds, isEnabled, data.getCheckComputerFieldObj);
    getModules?.forEach((module) => {
      module?.modules?.forEach((item) => {
        if (item.fieldType == 24 && item?.settingId) {
          //启用的是计算字段
          if (isEnabled && !data.getCheckComputerFieldObj?.[item.settingId]) {
            const setParams = { settingId: item.settingId, apiIndex: Math.random() };
            if (getTempSettingIds?.tempSettingIds) {
              setParams.tempSettingIds = getTempSettingIds?.tempSettingIds || '';
            }
            if (getTempSettingIds?.tempDisableSettingIds) {
              setParams.tempDisableSettingIds = getTempSettingIds?.tempDisableSettingIds || '';
            }
            setFieldAllPromises.push(computerFieldCheck(setParams, data.getCheckComputerFieldObj));
          }
        }
      });
    });
    if (setFieldAllPromises?.length > 0) {
      await Promise.all(setFieldAllPromises);
    }
    for (const key in data.getCheckComputerFieldObj) {
      if (data.getCheckComputerFieldObj?.[key]?.resultSetting?.length > 0) {
        const resultSettings = data.getCheckComputerFieldObj[key].resultSetting;
        const hasMatchingSetting = resultSettings.some((setting) => setting[setKey]?.some((id) => paramIds.has(id)));
        // console.log('hasMatchingSetting----------', hasMatchingSetting);
        if (hasMatchingSetting) {
          updateSettingIds(resultSettings, paramIds, setKey, setKey2);
        }
      }
    }

    updateCheckResult();
    // console.log('data.getCheckComputerFieldObj-----', data.getCheckComputerFieldObj);
  };
  // 复制计算字段时更新异常信息
  const copyCheckComputerField = async (params, fieldKey) => {
    data.getCheckComputerFieldObj[fieldKey] = data.getCheckComputerFieldObj[params.settingId];
    // console.log('data.getCheckComputerFieldObj-----', data.getCheckComputerFieldObj);
  };
  // 检查单个项是否有效
  const isValidItem = (item) => {
    const label = String(item?.label)?.replace(/\s+/g, '');
    const value = String(item?.value)?.replace(/\s+/g, '');

    // 检查空值
    if (label === '' || value === '') {
      return false;
    }

    // 检查长度限制
    if (item?.label?.length > 300) {
      return false;
    }

    return true;
  };
  const checkForDuplicates = (field) => {
    const labels = new Set();
    const values = new Set();
    const getFieldExt = field.fieldExt;
    if (getFieldExt?.length > confine.number3000) {
      //选项超出限额
      return false;
    }

    for (var index = 0; index < getFieldExt.length; index++) {
      const item = getFieldExt[index];
      // 检查单个项是否有效
      if (!isValidItem(item)) {
        return false;
      }
      const label = item.label;
      const value = item.value;
      // 检查重复
      if (labels.has(label) || values.has(value)) {
        return false;
      }

      // 添加到集合中
      labels.add(label);
      values.add(value);
      if (item?.children && item.children?.length > 0) {
        //级联
        const flag = checkForDuplicates({ fieldExt: item.children });
        if (!flag) return flag;
      }
    }

    return true;
  };
  // 选择类表单组件 选项去重
  const judgeRepeatData = (field) => {
    if (field.checkedValue == 0) {
      //非全局字段
      field.fieldExt = tools.isJSON(field.fieldExt) ? JSON.parse(field.fieldExt) : field.fieldExt ?? null;
      if (field?.fieldExt) {
        const flag = checkForDuplicates(field);
        if (!flag) return false;
      }
    }
    if (field.checkedValue == 1 && !field.globalFieldId) {
      //全局字段
      return false;
    }

    return true;
  };
  // 检测字段信息是否完整
  const verifyCompleteness = (field) => {
    if (!field?.label) {
      //字段名称为空
      return true;
    }
    if (data.selectFieldTypes.includes(field.fieldType)) {
      //选择类型的
      if (field?.systemFieldtype == 1 && field?.fieldKey == 'entityType') {
        //数据来源不校验重复
        return false;
      }
      if (!judgeRepeatData(field)) {
        //选项有异常
        return true;
      }
    }
    if (data.relationFieldTypes.includes(field.fieldType)) {
      //查找关联

      if (!field.dataRange || field.selectFields?.length == 0 || field.popFields?.length == 0) {
        return true;
      }
    }
    if (field.fieldType == 21) {
      //引用字段
      field.fieldExt = tools.isJSON(field.fieldExt) ? JSON.parse(field.fieldExt) : field.fieldExt ?? null;
      if (!field.fieldExt || !field?.fieldExt?.findAssociateField || !field?.fieldExt?.referenceField) {
        return true;
      }
    }
    if (field.fieldType == 24) {
      //计算字段

      if (!field?.fieldExt || isNaN(field?.computeType)) {
        return true;
      }

      if (field?.computeType == 5 || field?.computeType == 5) {
        //汇总-数字，汇总-金额
        if (!field?.sum) {
          return true;
        }
      } else {
        if (field?.computeType == 7 || field?.computeType == 16 || field?.computeType == 23 || field?.computeType == 0) {
          //数字金额百分比文本
          if (!field?.compute || !field?.computeFormulaUi) {
            return true;
          }
        }
      }

      //编辑
      if ((field?.settingId && data.getCheckComputerFieldObj[field?.settingId]?.checkResult == false) || (field?.fieldKey && data.getCheckComputerFieldObj[field?.fieldKey]?.checkResult == false)) {
        return true;
      }
    }
    if (field.fieldType == 13) {
      //编码
      if (field?.fieldExt == 2) {
        //条件编码
        if (!field?.encodings || field?.encodings?.length == 0) {
          return true;
        }
        const getEncodings = field?.encodings || [];
        for (let i = 0; i < getEncodings?.length; i++) {
          if (getEncodings[i]?.type == 2 && (!getEncodings[i].conditionVo || !getEncodings[i].conditionVo?.children || getEncodings[i]?.conditionVo?.children?.length == 0)) {
            //没有配置条件
            return true;
          }
        }
      }
    }
    if (field.fieldType == 18) {
      //附件
      const fieldExt = tools.isJSON(field.fieldExt) ? JSON.parse(field.fieldExt) : field.fieldExt ?? null;
      if (fieldExt.fileType == 1) {
        //文件
        if (!fieldExt?.accept || fieldExt?.accept?.length == 0) {
          //文件类型
          return true;
        }
      }
    }
    return false;
  };
  //判断是否为json字符串
  //   const isJSON = (str) => {
  //     if (typeof str !== 'string') return false;
  //     try {
  //       const result = JSON.parse(str);
  //       // 检查解析结果是否为对象或数组（非 null），以确保是 JSON 格式
  //       const isObject = result && (typeof result === 'object' || Array.isArray(result));
  //       return isObject;
  //     } catch (e) {
  //       return false;
  //     }
  //   };
  const fieldExtDelId = (v) => {
    //判断如果不是json字符串直接返回
    // console.log('isJSON(v)000', isJSON(v));
    // if (!isJSON(v)) {
    //   return v;
    // }
    // console.log('v---------', v);
    const fieldExt = tools.isJSON(v) ? JSON.parse(v) : v;
    if (Array.isArray(fieldExt)) {
      fieldExt.forEach((element) => {
        if (element.id) {
          delete element.id;
        }
      });
    } else if (typeof fieldExt == 'object') {
      if (fieldExt?.id) {
        delete fieldExt.id;
      }
    } else {
      return v;
    }
    return JSON.stringify(fieldExt);
  };

  const setDefaultParames = (params) => {
    const getIsExistDefValue = params.isExistDefValue; //默认值类型（新值），params.defValType是旧值
    const getFieldType = params?.fieldType; //字段类型
    const getDefVal = params?.defVal || ''; //默认值对象
    const getDefValId = params?.defValId || ''; //默认值id
    const getDefaultValue = params?.defaultValue ?? ''; //默认值字符串
    const setDefaultObj = {
      defValType: getIsExistDefValue, //默认值类型
      defaultValue: null //默认值
    };
    if (getIsExistDefValue == 1) {
      // 自定义默认值对象
      if (getFieldType == 27) {
        setDefaultObj.defaultValue = {
          defVal: getDefVal?.length ? JSON.stringify(defaultValFormatSubForm(getDefVal)) : null,
          id: getDefValId || ''
        };
      } else {
        const setDefaultValObj = {
          defaultValue: getDefaultValue, //默认值
          fieldType: getFieldType
        };
        uploadDefaultVal(setDefaultValObj);
        setDefaultObj.defaultValue = { defVal: setDefaultValObj.defaultValue, id: getDefValId || '' };
      }
    }
    if ([3, 4].includes(getIsExistDefValue)) {
      // 查找他表，计算公式
      if (getDefVal) {
        setDefaultObj.defValType = getIsExistDefValue;
        setDefaultObj.defaultValue = { ...getDefVal, id: getDefValId || '' };
        if (getDefValId) {
          //编辑
          if ([3, 4].includes(params?.defValType)) {
            //查询他表,计算公式
            if ((getIsExistDefValue == 3 && getDefVal?.computeFormulaUi && getDefVal?.computeFormula) || (getIsExistDefValue == 4 && getDefVal?.sourceEntity)) {
              if (params?.defValType != getIsExistDefValue) {
                //新旧值类型不相同，配置也不相同
                setDefaultObj.defValType = params.defValType;
              } else {
                //新旧值类型相同，配置不相同
                setDefaultObj.defValType = 0;
                setDefaultObj.defaultValue = null;
              }
            }
          }
        } else {
          //新增
          if ((getIsExistDefValue == 3 && getDefVal?.computeFormulaUi && getDefVal?.computeFormula) || (getIsExistDefValue == 4 && getDefVal?.sourceEntity)) {
            setDefaultObj.defValType = 0;
            setDefaultObj.defaultValue = null;
          }
        }
      } else {
        setDefaultObj.defValType = 0;
        setDefaultObj.defaultValue = null;
      }
    }
    return setDefaultObj;
  };
  // 保存或编辑字段
  // 组装字段请求参数
  const getRequestParams = async (getParams) => {
    let parentExt = null;
    const fields = getParams.field;
    const getGroupData = getParams?.modules;
    getGroupData?.forEach((el) => {
      el.modules?.forEach((module) => {
        if (module.fieldType == 27 && module.modules?.length > 0) {
          module.modules?.forEach((sub) => {
            if (sub.fieldKey == fields.fieldKey) {
              //找到了子字段
              parentExt = module.fieldExt;
            }
          });
        }
      });
    });

    const getFieldItem = _.cloneDeep(fields);
    if (data.noFeildExt.includes(fields?.fieldType)) {
      getFieldItem.fieldExt = null;
    } else if (data.noJsonFeildExt.includes(fields?.fieldType)) {
      getFieldItem.fieldExt = fields?.fieldExt || null;
    } else {
      if (getFieldItem?.fieldExt && (typeof getFieldItem?.fieldExt != 'string' || typeof getFieldItem?.fieldExt == 'object')) {
        if (getParams.entityId == 4 && getFieldItem?.fieldType === 4 && getFieldItem.fieldKey === 'taxRate') {
          //产品的税率
          getFieldItem?.fieldExt?.forEach((i) => {
            i.label = i?.label && !isNaN(i.label) ? Number(i.label) : '';
          });
        }
        getFieldItem.fieldExt = JSON.stringify(getFieldItem?.fieldExt);
      }
    }
    const { settingId, label, fieldKey, fieldType, isEnabled, isRequired, attributeRead, attributeHide, fieldExt, globalFieldId, selectFields, outShowField, popFields, dataRange, fieldAssignment, dataRangeConditions, encodings, sum, computeType, compute, computeFormulaUi, settings, isExistDefValue, defValType, defaultValue, defVal, defValId } = getFieldItem;
    const params = { id: settingId || '', entityId: getParams.entityId, fieldName: label, fieldKey, fieldType, isEnabled, isRequired, attributeRead, attributeHide, fieldExt: fieldExt };

    if (parentExt) {
      //编辑,新增的是子字段
      params.entityId = parentExt;
      params.isEnabled = true;
    }
    if (data.selectFieldTypes.includes(fieldType)) {
      //选项类型的
      params.fieldExt = getFieldItem.checkedValue === 0 ? fieldExt : undefined;
      params.globalFieldId = getFieldItem.checkedValue === 1 ? globalFieldId : undefined;
    }
    if (fieldType === 24) {
      params.sum = sum;
      params.computeType = computeType;
      params.compute = compute;
      params.computeFormulaUi = computeFormulaUi;
    } else if (fieldType === 12 || fieldType === 25) {
      params.dataRange = dataRange;
      // params.dataRangeConditions = condition ? setCondition(dataRangeConditions) : dataRangeConditions;
      params.dataRangeConditions = dataRangeConditions; // 数据范围条件格式化在条件组件抛出数据时处理
      params.outShowField = outShowField;
      params.selectFields = selectFields;
      params.popFields = popFields;
      params.fieldAssignment = fieldAssignment;
    } else if (fieldType === 13) {
      params.encodings = encodings;
    } else if (fieldType === 27) {
      params.settings = settings ? settings : [];
      params.settingId = settingId;
      // params.type = 3; // 对象类型1, 系统对象，2自定义对象 3 子对象(子表单)
    }

    // 补充引用字段新增 取消非必填逻辑
    if (params.fieldType == 21) params.isRequired = false;
    if (fieldType === 27 && params.settings?.length && getFieldItem.isClone) {
      //复制子表单加一个标识
      // 复制子表单的情况
      const paramsSettings = params.settings?.map((item) => ({
        fieldName: item.label,
        fieldKey: item.fieldKey,
        fieldType: item.fieldType,
        isRequired: item.isRequired,
        fieldExt: item.fieldExt ? fieldExtDelId(item.fieldExt) : null,
        id: null,
        modulesId: null,
        parentId: null,
        settingId: null,
        isEnabled: true,
        layoutId: null,
        complete: verifyCompleteness(item) ? false : true,
        isExistDefValue: 0,
        defaultValue: null
      }));

      params.settings?.forEach((element, index) => {
        if (data.selectFieldTypes.includes(element.fieldType)) {
          //选项类型的
          paramsSettings[index].globalFieldId = element.checkedValue === 1 ? element.globalFieldId : undefined;
        }
        if (element.fieldType === 12 || element.fieldType === 25) {
          paramsSettings[index].dataRange = element.dataRange;
          paramsSettings[index].dataRangeConditions = element.dataRangeConditions; // 数据范围条件格式化在条件组件抛出数据时处理
          paramsSettings[index].selectFields = element.selectFields;
          paramsSettings[index].outShowField = element.outShowField;
          paramsSettings[index].popFields = element.popFields;
        }
        // 补充引用字段新增 取消非必填逻辑
        if (element.fieldType == 21) paramsSettings[index].isRequired = false;
      });
      params.settings = paramsSettings;
    }
    const getDefaultObj = setDefaultParames({ isExistDefValue, defValType, defaultValue, defVal, defValId, fieldType });

    params.defValType = getDefaultObj.defValType; //默认值类型
    params.defaultValue = getDefaultObj.defaultValue; //默认值
    params.complete = verifyCompleteness(getFieldItem) ? false : true; //false是异常 true是非异常
    return params;
  };
  // 编辑接口
  const updateSettingField = async (getParams) => {
    try {
      const params = await getRequestParams(getParams);
      const res = await setService.updateSettingField(params);
      const fieldForm = getParams.field;
      if (!res.error) {
        fieldForm.isModify = false;
        fieldForm.complete = params.complete;
        if (data.selectFieldTypes.includes(fieldForm.fieldType)) {
          //选项类型
          if (res?.result?.fieldExt && tools.isJSON(res?.result?.fieldExt)) {
            fieldForm.fieldExt = JSON.parse(res?.result?.fieldExt) || null;
          }
        } else if (fieldForm.fieldType == 27) {
          fieldForm.fieldExt = res?.result?.fieldExt;
        }
      } else {
        Message.error(res.error?.msg || '操作失败');
      }
      data.fieldForm = fieldForm;
    } catch (e) {
      data.fieldForm = null;
    }
  };

  // 新增接口
  const addSettingField = async (getParams) => {
    try {
      const params = await getRequestParams(getParams);
      const res = await setService.addSettingField(params);
      const fieldForm = getParams.field;
      if (!res.error) {
        fieldForm.settingId = res.result?.id;
        fieldForm.complete = params.complete;
        fieldForm.isModify = false;
        if (fieldForm.fieldType == 27) {
          //子表
          fieldForm.fieldExt = res.result?.fieldExt;

          // 创建一个映射，用于快速查找 settings 中的对象
          const settingsById = new Map(res.result?.settings?.map((item) => [item.fieldKey, item]));

          // 更新 data.modules 数组中的 id 属性
          fieldForm?.modules?.forEach((item) => {
            item.entityId = res.result?.fieldExt ? res.result.fieldExt : '';
            const matchingItem = settingsById.get(item.fieldKey);
            if (matchingItem && matchingItem?.id) {
              item.settingId = matchingItem.id;
            }
            if (!item.entityId) {
              //如果entityId不存在就赋值
              item.entityId = matchingItem.entityId;
            }
          });
          fieldForm.settings = res.result?.settings;
          const params = {
            settingId: res.result?.id,
            fieldType: 27
          };
          await getEntityFieldExt(params, false);
          const business = data.entitySettingFieldExt?.business && tools.isJSON(data.entitySettingFieldExt?.business) ? JSON.parse(data.entitySettingFieldExt?.business) : {};
          fieldForm.businessData = business?.businessData || null; //子表单对象id
          fieldForm.associateKey = business?.associateKey || null; //子表单关联主键

          settingStore.updateSubNum(settingStore.setSubNum + 1); //存储子表单数据
        } else if (data.selectFieldTypes.includes(fieldForm.fieldType)) {
          //选项类型
          if (res?.result?.fieldExt && tools.isJSON(res?.result?.fieldExt)) {
            fieldForm.fieldExt = JSON.parse(res?.result?.fieldExt) || null;
          }
        }
      } else {
        Message.error(res.error?.msg || '操作失败');
      }
      data.fieldForm = fieldForm;
    } catch (e) {
      data.fieldForm = null;
    }
  };
  const updateField = async (getParams) => {
    if (getRecordType(getParams?.field?.type)) {
      //当右侧配置区域保存时，关联对象表格不做处理
      const fieldForm = getParams.field;
      fieldForm.isModify = false;
      data.fieldForm = fieldForm;
      return false;
    }
    //当前表单点击保存
    if (getParams?.field?.settingId) {
      //编辑
      await updateSettingField(getParams);
    } else {
      //新增
      await addSettingField(getParams);
    }
  };
  // 检测规则互斥
  const checkDefaultRule = async (params, fieldName, checkRuleType = 1) => {
    data.getDefaultRule = false;
    const getParams = { ...params, apiIndex: Math.random() * 100 };
    try {
      const res = await setService.checkDefaultRule(getParams);
      const getDefaultRule = res?.result || null;
      if (getDefaultRule) {
        if (getDefaultRule?.existAssignmentRule && checkRuleType == 1) {
          //存在赋值规则
          Message.warning(`字段【${fieldName}】，已被【${getDefaultRule?.referenceField?.[0]?.fieldName || '未知'}】的赋值规则引用`);
          data.getDefaultRule = true;
        }
        if (getDefaultRule?.existDefaultValue && checkRuleType == 2) {
          //存在默认值
          Message.warning(`字段【${fieldName}】，已设置默认值，无法进行关联数据填充`);
          data.getDefaultRule = true;
          return true;
        }
      }
    } catch (e) {
      console.log('错误', e);
    }
  };
  // 检测是否为记录类型
  const getRecordType = (type) => {
    return [30, 31].includes(Number(type));
  };
  //设置记录的label
  const setRecordLabel = (ele) => {
    return ele?.label ? ele?.label : (ele?.layoutFieldType || ele?.type) == 31 ? i18n.global.t('查询记录') : i18n.global.t('关联记录');
  };
  // 获取字段icon
  const componentFun = (ele) => {
    const getType = getRecordType(ele?.type || ele.layoutFieldType) ? ele?.type || ele.layoutFieldType : ele?.fieldType;
    return fieldIconMapping.value[Number(getType)];
  };
  return {
    createFieldKey,
    setRecordLabel,
    updateModules,
    getFieldDefaultValue,
    updateSettings,
    filterModules,
    getTable,
    getFormatModules,
    filterIsEnabledModules,
    getFieldTypeList,
    checkSubFormNums,
    getEntityFieldExt,
    getAllFields,
    fitterDefaultValue,
    filterSelectDefaultValue,
    checkComputerField,
    updateComputerCheckError,
    updateCheckComputerField,
    copyCheckComputerField,
    updateCheckResultError,
    verifyCompleteness,
    updateField,
    getGrayscale,
    defaultValFormatSubForm,
    uploadDefaultVal,
    checkDefaultRule,
    getRecordType,
    componentFun,
    ...toRefs(data)
  };
}
